import React, { useMemo } from 'react';
import { AgGridTable } from 'components/common';
import PropTypes from 'prop-types';

const LeadTable = ({data}) => {
  const leadUrl = "/crm/leads";

  const columns = useMemo(() => [
    {
      field: 'id',
      headerName: 'ID#',
      width: 100,
      filter: 'agTextColumnFilter',
      cellRenderer: params => (
        <a href={`${leadUrl}/${params.data.id}`} target="_blank" rel="noreferrer" className="tw-text-blue-600">
          {params.data.lead_code}
        </a>
      )
    },
    {
      field: 'name',
      headerName: 'Lead name',
      flex: 1.5,
      filter: 'agTextColumnFilter',
      cellRenderer: params => (
        <a href={`${leadUrl}/${params.data.id}`} target="_blank" rel="noreferrer" className="tw-font-semibold tw-text-blue-600">
          {params.data.name}
        </a>
      )
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 120,
      filter: 'agTextColumnFilter',
      valueGetter: params => params.data.status?.name || '',
      cellRenderer: params => params.data.status?.name || '—'
    },
    {
      field: 'stage',
      headerName: 'Stage',
      width: 100,
      filter: 'agTextColumnFilter'
    },
    {
      field: 'mql_status',
      headerName: 'MQL status',
      width: 100,
      filter: 'agTextColumnFilter'
    },
    {
      field: 'owner_by',
      headerName: 'Owner',
      flex: 1,
      filter: 'agTextColumnFilter'
    },
    {
      field: 'project_name',
      headerName: 'Project name',
      flex: 1.2,
      filter: 'agTextColumnFilter'
    },
    {
      field: 'sales_unit',
      headerName: 'Sales unit',
      flex: 1,
      filter: 'agTextColumnFilter',
      valueGetter: params => params.data.sales_unit?.description || '',
      cellRenderer: params => params.data.sales_unit?.description || '—'
    },
    {
      field: 'created_by',
      headerName: 'Created by',
      flex: 1,
      filter: 'agTextColumnFilter'
    },
    {
      field: 'created_date',
      headerName: 'Created date',
      flex: 1,
      filter: 'agTextColumnFilter'
    }
  ], [leadUrl]);

  if (!data) {
    return null;
  }

  return (
    <AgGridTable
      columnDefs={columns}
      rowData={data}
      height="400px"
      sort
      filter
    />
  );
};

LeadTable.propTypes = {
  data: PropTypes.array.isRequired
};

export default LeadTable;